export default __webpack_public_path__ + "static/Eco_Alliance_Default_blog-997bc287cb08cc85beb3087c28a6efff.svg";